var _defs, _path, _path2, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgWs = function SvgWs(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 2880 1440"
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "ws_svg__a",
    d: "m0 0 .309.951L-.5.363h1l-.809.588z"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#ce1126",
    d: "M0 0h2880v1440H0z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#002b7f",
    d: "M0 0h1440v720H0z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#ws_svg__a",
    transform: "matrix(160 0 0 160 720 30)"
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#ws_svg__a",
    transform: "matrix(160 0 0 160 500 210)"
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#ws_svg__a",
    transform: "matrix(150 0 0 150 945 180)"
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#ws_svg__a",
    transform: "matrix(100 0 0 100 830 364.894)"
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#ws_svg__a",
    transform: "matrix(200 0 0 200 720 499.789)"
  }))));
};
export default SvgWs;